/* eslint-disable jira/filename-case */
import { NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP } from './constants.tsx';
import type { DraggableProjectData } from './types.tsx';

export const isDraggableProject = (
	data: Record<string | symbol, unknown>,
): data is DraggableProjectData => {
	return Boolean(data.type === NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP);
};
